import { prepareSortedOptions } from '../../prepareOptions';

import {
  IS_BIO_DIESEL_SUITABLE,
  IS_NON_SMOKER_VEHICLE,
  HAS_PADDLE_SHIFTERS,
  HAS_WARRANTY,
  HAS_RANGE_EXTENDER,
} from './values';

export default prepareSortedOptions([
  {
    value: IS_BIO_DIESEL_SUITABLE,
    label: __('carDetails.features.isBioDieselSuitable'),
  },
  {
    value: IS_NON_SMOKER_VEHICLE,
    label: __('carDetails.features.isNonSmokerVehicle'),
  },
  {
    value: HAS_PADDLE_SHIFTERS,
    label: __('carDetails.features.hasPaddleShifters'),
  },
  {
    value: HAS_RANGE_EXTENDER,
    label: __('carDetails.features.hasrangeExtender'),
  },
  {
    value: HAS_WARRANTY,
    label: __('carDetails.features.hasWarranty'),
  },
]);
